import { c as _c } from "react/compiler-runtime";
import type { ContentSpacingToken, StructuredContentDocument } from '../../types';
const SPACING_VARS: Record<string, string> = {
  xxs: 'var(--spacing-content-xxs, 4px)',
  xs: 'var(--spacing-content-xs, 8px)',
  sm: 'var(--spacing-content-sm, 12px)',
  md: 'var(--spacing-content-md, 16px)',
  lg: 'var(--spacing-content-lg, 24px)',
  xl: 'var(--spacing-content-xl, 32px)',
  xxl: 'var(--spacing-content-xxl, 48px)'
};
type SpacerProps = StructuredContentDocument<{
  spacing: ContentSpacingToken;
}>;
export const Spacer = t0 => {
  const $ = _c(2);
  const {
    props
  } = t0;
  const {
    spacing: spacingToken
  } = props;
  const marginBottom = SPACING_VARS[spacingToken];
  let t1;
  if ($[0] !== marginBottom) {
    t1 = <div style={{
      marginBottom
    }} />;
    $[0] = marginBottom;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};